import { Route } from "@angular/router";
import { FazerTransferenciaDetalhePage } from "./fazer-transferencia-detalhe.page";

export const FazerTransferenciaDetalheRouter: Route[] = [
  { path: 'fazer-transferencia-detalhe', component: FazerTransferenciaDetalhePage }
];
